"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchService = exports.batchProgressCount = void 0;
const uuid_1 = require("uuid");
const p_queue_1 = __importStar(require("@esm2cjs/p-queue"));
const core_1 = require("../core");
const membership_1 = require("./membership");
const stack_1 = require("./stack");
const node_1 = require("./node");
const membership_2 = require("../types/membership");
const file_1 = require("./file");
const constants_1 = require("../constants");
const contract_1 = require("../types/contract");
const bad_request_1 = require("../errors/bad-request");
const types_1 = require("../types");
const lodash_1 = __importDefault(require("lodash"));
class BatchService extends core_1.Service {
    /**
     * @param  {{id:string,type:NoteType}[]} items
     * @returns Promise with corresponding transaction ids
     */
    revoke(items) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.batchUpdate(items.map((item) => (Object.assign(Object.assign({}, item), { input: { function: constants_1.functions.NODE_REVOKE }, actionRef: item.type.toUpperCase() + "_REVOKE" }))));
        });
    }
    /**
     * @param  {{id:string,type:NoteType}[]} items
     * @returns Promise with corresponding transaction ids
     */
    restore(items) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.batchUpdate(items.map((item) => (Object.assign(Object.assign({}, item), { input: { function: constants_1.functions.NODE_RESTORE }, actionRef: item.type.toUpperCase() + "_RESTORE" }))));
        });
    }
    /**
     * @param  {{id:string,type:NodeType}[]} items
     * @returns Promise with corresponding transaction ids
     */
    delete(items) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.batchUpdate(items.map((item) => (Object.assign(Object.assign({}, item), { input: { function: constants_1.functions.NODE_DELETE }, actionRef: item.type.toUpperCase() + "_DELETE" }))));
        });
    }
    /**
     * @param  {{id:string,type:NodeType}[]} items
     * @returns Promise with corresponding transaction ids
     */
    move(items, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.batchUpdate(items.map((item) => (Object.assign(Object.assign({}, item), { input: {
                    function: constants_1.functions.NODE_MOVE,
                    parentId: parentId
                }, actionRef: item.type.toUpperCase() + "_MOVE" }))));
        });
    }
    /**
     * @param  {{id:string,role:RoleType}[]} items
     * @returns Promise with corresponding transaction ids
     */
    membershipChangeRole(items) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.batchUpdate(items.map((item) => ({
                id: item.id,
                type: constants_1.objectType.MEMBERSHIP,
                input: {
                    function: constants_1.functions.MEMBERSHIP_CHANGE_ROLE,
                    role: item.role
                },
                actionRef: constants_1.actionRefs.MEMBERSHIP_CHANGE_ROLE
            })));
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {{file:FileSource,options:StackCreateOptions}[]} items
     * @param  {BatchStackCreateOptions} [options]
     * @returns Promise with new stack ids & their corresponding transaction ids
     */
    stackCreate(vaultId, items, options = {}) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const data = [];
            const errors = [];
            // prepare items to upload
            const stackUploadItems = yield Promise.all(items.map((item) => __awaiter(this, void 0, void 0, function* () {
                const fileLike = yield (0, file_1.createFileLike)(item.file, item.options || {});
                return {
                    file: fileLike,
                    options: item.options
                };
            })));
            const [itemsToUpload, emptyFileItems] = lodash_1.default.partition(stackUploadItems, function (item) { var _a; return ((_a = item.file) === null || _a === void 0 ? void 0 : _a.size) > 0; });
            emptyFileItems.map((item) => {
                var _a;
                errors.push({ name: (_a = item.file) === null || _a === void 0 ? void 0 : _a.name, message: stack_1.EMPTY_FILE_ERROR_MESSAGE, error: new bad_request_1.BadRequest(stack_1.EMPTY_FILE_ERROR_MESSAGE) });
            });
            const batchSize = itemsToUpload.reduce((sum, item) => {
                return sum + item.file.size;
            }, 0);
            (0, exports.batchProgressCount)(batchSize, options);
            // set service context
            const vault = yield this.api.getVault(vaultId);
            const batchService = new BatchService(this.wallet, this.api);
            batchService.setVault(vault);
            batchService.setVaultId(vaultId);
            batchService.setIsPublic(vault.public);
            yield batchService.setMembershipKeys(vault);
            batchService.setGroupRef(items);
            batchService.setActionRef(constants_1.actionRefs.STACK_CREATE);
            batchService.setFunction(constants_1.functions.NODE_CREATE);
            const stackCreateOptions = Object.assign(Object.assign({}, options), { cloud: batchService.vault.cloud, storage: batchService.vault.cloud ? types_1.StorageType.S3 : types_1.StorageType.ARWEAVE });
            let stacksCreated = 0;
            const uploadQ = new p_queue_1.default({ concurrency: BatchService.BATCH_CONCURRENCY, });
            const postTxQ = new p_queue_1.default({ concurrency: BatchService.BATCH_CONCURRENCY });
            const uploadItem = (item) => __awaiter(this, void 0, void 0, function* () {
                var _f, _g, _h;
                const service = new stack_1.StackService(this.wallet, this.api, batchService);
                const nodeId = (0, uuid_1.v4)();
                service.setObjectId(nodeId);
                const createOptions = Object.assign(Object.assign({}, stackCreateOptions), (item.options || {}));
                service.setAkordTags((service.isPublic ? [item.file.name] : []).concat(createOptions.tags));
                service.setParentId(createOptions.parentId);
                service.arweaveTags = yield service.getTxTags();
                const fileService = new file_1.FileService(this.wallet, this.api, service);
                try {
                    const fileUploadResult = yield fileService.create(item.file, createOptions);
                    const version = yield fileService.newVersion(item.file, fileUploadResult);
                    const state = {
                        name: yield service.processWriteString(item.file.name),
                        versions: [version],
                        tags: service.tags
                    };
                    const id = yield service.uploadState(state, service.vault.cloud);
                    postTxQ.add(() => postTx({
                        vaultId: service.vaultId,
                        input: { function: service.function, data: id, parentId: createOptions.parentId },
                        tags: service.arweaveTags,
                        item
                    }), { signal: (_f = options.cancelHook) === null || _f === void 0 ? void 0 : _f.signal });
                }
                catch (error) {
                    if (!(error instanceof p_queue_1.AbortError) && !((_h = (_g = options.cancelHook) === null || _g === void 0 ? void 0 : _g.signal) === null || _h === void 0 ? void 0 : _h.aborted)) {
                        errors.push({ name: item.file.name, message: error.toString(), error });
                    }
                }
            });
            const postTx = (tx) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const { id, object } = yield this.api.postContractTransaction(tx.vaultId, tx.input, tx.tags);
                    const stack = yield new stack_1.StackService(batchService.wallet, batchService.api, batchService)
                        .processNode(object, !batchService.isPublic, batchService.keys);
                    if (options.onStackCreated) {
                        yield options.onStackCreated(stack);
                    }
                    data.push({ transactionId: id, object: stack, stackId: object.id });
                    stacksCreated += 1;
                }
                catch (error) {
                    errors.push({ name: tx.item.name, message: error.toString(), error });
                }
                ;
            });
            try {
                yield uploadQ.addAll(itemsToUpload.map(item => () => uploadItem(item)), { signal: (_a = options.cancelHook) === null || _a === void 0 ? void 0 : _a.signal });
            }
            catch (error) {
                if (!(error instanceof p_queue_1.AbortError) && !((_c = (_b = options.cancelHook) === null || _b === void 0 ? void 0 : _b.signal) === null || _c === void 0 ? void 0 : _c.aborted)) {
                    errors.push({ message: error.toString(), error });
                }
            }
            yield postTxQ.onIdle();
            if ((_e = (_d = options.cancelHook) === null || _d === void 0 ? void 0 : _d.signal) === null || _e === void 0 ? void 0 : _e.aborted) {
                return ({ data, errors, cancelled: itemsToUpload.length - stacksCreated });
            }
            return { data, errors, cancelled: 0 };
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {{email:string,role:RoleType}[]} items
     * @param  {MembershipCreateOptions} [options] invitation email message, etc.
     * @returns Promise with new membership ids & their corresponding transaction ids
     */
    membershipInvite(vaultId, items, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const members = yield this.api.getMembers(vaultId);
            const data = [];
            const errors = [];
            const transactions = [];
            // set service context
            const batchService = new BatchService(this.wallet, this.api);
            batchService.setGroupRef(items);
            const vault = yield this.api.getVault(vaultId);
            batchService.setVault(vault);
            batchService.setVaultId(vaultId);
            batchService.setIsPublic(vault.public);
            yield batchService.setMembershipKeys(vault);
            batchService.setActionRef(constants_1.actionRefs.MEMBERSHIP_INVITE);
            batchService.setFunction(constants_1.functions.MEMBERSHIP_INVITE);
            // upload metadata
            yield Promise.all(items.map((item) => __awaiter(this, void 0, void 0, function* () {
                const email = item.email.toLowerCase();
                const role = item.role;
                const member = members.find(item => { var _a; return ((_a = item.email) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === email; });
                if (member && membership_2.activeStatus.includes(member.status)) {
                    const message = "Membership already exists for this user.";
                    errors.push({ email: email, message, error: new bad_request_1.BadRequest(message) });
                }
                else {
                    const userHasAccount = yield this.api.existsUser(email);
                    const service = new membership_1.MembershipService(this.wallet, this.api, batchService);
                    if (userHasAccount) {
                        const membershipId = (0, uuid_1.v4)();
                        service.setObjectId(membershipId);
                        const { address, publicKey, publicSigningKey } = yield this.api.getUserPublicData(email);
                        const state = {
                            keys: yield service.prepareMemberKeys(publicKey),
                            encPublicSigningKey: yield service.processWriteString(publicSigningKey)
                        };
                        service.arweaveTags = [new contract_1.Tag(constants_1.protocolTags.MEMBER_ADDRESS, address)]
                            .concat(yield service.getTxTags());
                        const dataTxId = yield service.uploadState(state, service.vault.cloud);
                        transactions.push({
                            vaultId,
                            input: { function: service.function, address, role, data: dataTxId },
                            tags: service.arweaveTags,
                            item: item
                        });
                    }
                    else {
                        try {
                            const { id } = yield this.api.inviteNewUser(vaultId, email, role, options.message);
                            data.push({
                                membershipId: id,
                                transactionId: null
                            });
                        }
                        catch (error) {
                            errors.push({
                                email: email,
                                error: error,
                                message: error.message,
                                item: item
                            });
                        }
                    }
                }
            })));
            for (let tx of transactions) {
                try {
                    const { id, object } = yield this.api.postContractTransaction(vaultId, tx.input, tx.tags, { message: options.message });
                    data.push({ membershipId: object.id, transactionId: id, object: new membership_2.Membership(object) });
                }
                catch (error) {
                    errors.push({
                        email: tx.item.email,
                        error: error,
                        message: error.message,
                        item: tx.item
                    });
                }
            }
            return { data: data, errors: errors };
        });
    }
    batchUpdate(items) {
        return __awaiter(this, void 0, void 0, function* () {
            const batchService = new BatchService(this.wallet, this.api);
            batchService.setGroupRef(items);
            const result = [];
            for (const [itemIndex, item] of items.entries()) {
                const node = item.type === constants_1.objectType.MEMBERSHIP
                    ? yield this.api.getMembership(item.id)
                    : yield this.api.getNode(item.id, item.type);
                if (itemIndex === 0 || batchService.vaultId !== node.vaultId) {
                    batchService.setVaultId(node.vaultId);
                    batchService.setIsPublic(node.__public__);
                    yield batchService.setMembershipKeys(node);
                }
                const service = item.type === constants_1.objectType.MEMBERSHIP
                    ? new membership_1.MembershipService(this.wallet, this.api, batchService)
                    : new node_1.NodeService(this.wallet, this.api, batchService);
                service.setFunction(item.input.function);
                service.setActionRef(item.actionRef);
                service.setObject(node);
                service.setObjectId(item.id);
                service.setObjectType(item.type);
                service.arweaveTags = yield service.getTxTags();
                const { id, object } = yield this.api.postContractTransaction(service.vaultId, item.input, service.arweaveTags);
                const processedObject = item.type === constants_1.objectType.MEMBERSHIP
                    ? new membership_2.Membership(object)
                    : yield service.processNode(object, !batchService.isPublic, batchService.keys);
                result.push({ transactionId: id, object: processedObject });
            }
            return result;
        });
    }
    setGroupRef(items) {
        this.groupRef = items && items.length > 1 ? (0, uuid_1.v4)() : null;
    }
}
exports.BatchService = BatchService;
BatchService.BATCH_CONCURRENCY = 50;
const batchProgressCount = (batchSize, options) => {
    let progress = 0;
    let uploadedItemsCount = 0;
    if (options.processingCountHook) {
        options.processingCountHook(uploadedItemsCount);
    }
    const perFileProgress = new Map();
    const uploadedFiles = new Set();
    if (options.progressHook) {
        const onProgress = options.progressHook;
        const itemProgressHook = (percentageProgress, binaryProgress, progressId) => {
            progress += binaryProgress - (perFileProgress.get(progressId) || 0);
            perFileProgress.set(progressId, binaryProgress);
            onProgress(Math.min(100, Math.round(progress / batchSize * 100)));
            if (percentageProgress === 100 && !uploadedFiles.has(progressId)) {
                uploadedFiles.add(progressId);
                uploadedItemsCount += 1;
                if (options.processingCountHook) {
                    options.processingCountHook(uploadedItemsCount);
                }
            }
        };
        options.progressHook = itemProgressHook;
    }
};
exports.batchProgressCount = batchProgressCount;
